import httpClient from "@/services/httpClient";
import { useUserStore } from "@/stores/user";

export const createMessage = async (requestId, messageBody, uploadKey = null) => {
  try {
    const userStore = useUserStore();
    const userName = userStore.user?.full_name || "Unknown User";
    const messageObj = { body: messageBody, source: "user", source_name: userName };
    if (uploadKey) {
      messageObj.attachment_keys = [uploadKey];
    }
    const response = await httpClient.post(`/api/v1/requests/${requestId}/messages`, {
      message: messageObj,
    });

    if (response.status !== 201) {
      throw new Error("Failed to create message");
    }
    return response.data?.request || null;
  } catch (error) {
    console.error(error);
    return null;
  }
};
